import request from '@/utils/request'

// 获取用户权限列表
export function getUserPermissions() {
  return request({
    url: '/permissions/users',
    method: 'get'
  })
}

// 获取单个用户的权限
export function getUserPermission(userId) {
  return request({
    url: `/permissions/users/${userId}`,
    method: 'get'
  })
}

// 更新用户权限
export function updateUserPermissions(userId, permissions) {
  return request({
    url: `/permissions/users/${userId}`,
    method: 'put',
    data: { permissions }
  })
}

// 创建权限组
export function createPermissionGroup(data) {
  return request({
    url: '/permission-groups',
    method: 'post',
    data
  })
}

// 获取权限组列表
export function getPermissionGroups() {
  return request({
    url: '/permission-groups',
    method: 'get'
  })
}

// 获取权限组详情
export function getPermissionGroup(groupId) {
  return request({
    url: `/permission-groups/${groupId}`,
    method: 'get'
  })
}

// 更新权限组
export function updatePermissionGroup(groupId, data) {
  return request({
    url: `/permission-groups/${groupId}`,
    method: 'put',
    data
  })
}

// 删除权限组
export function deletePermissionGroup(groupId) {
  return request({
    url: `/permission-groups/${groupId}`,
    method: 'delete'
  })
} 

// 获取权限字段配置
export function getPermissionFields() {
  return request({
    url: '/permission-groups/fields',
    method: 'get'
  })
}